export function PMSLocationInfo({
    uid,
    name,
    timezone,
    locationId,
    isProtectOn,
    protectAutoEnabledWithoutReservations,
    rooms,
    allowsCustomization,
    allowsProtect,
    hasProtectSubscription,
    invitationsAllowed,
    invitationsLeft,
    canCreateSuperguest,
    permission,
    isNotificationsActive,
    vacationRentalPlan,
    urlRecommendations,
    travelerDiscount,
    videoName,
    videoUrl,
    externalVideoUrl,
    publicDeviceOverrides = [],
    invitationLinkAddToHome = false,
    invitationLinkAppName = "",
    invitationLinkHideHeader = false,
    invitationLinkHideFooter = false,
    invitationLinkDisableLocationCheck = false,
    invitationLinkLocationCheckMode = "warn",
    invitationLinkLocationRadius = 200,
    latitude = null,
    longitude = null,
    address = "",
    earlyCheckinEnabled = false,
    earlyCheckoutEnabled = false,
    enableProtectGuest = false,
    securityAlertTime = 0,
    // Null means an older API response without inheritance metadata. When it
    // is an object, a key is present only if that value is owned by the
    // location; missing keys are inherited from the organization.
    ownSettings = null,
    settingsOrganizationName = null,
} = {}) {
    return {
        uid,
        name,
        timezone,
        locationId,
        isProtectOn,
        protectAutoEnabledWithoutReservations,
        rooms,
        allowsCustomization,
        allowsProtect,
        hasProtectSubscription,
        invitationsAllowed,
        invitationsLeft,
        canCreateSuperguest,
        permission,
        isNotificationsActive,
        vacationRentalPlan,
        urlRecommendations,
        travelerDiscount,
        videoName,
        videoUrl,
        externalVideoUrl,
        publicDeviceOverrides,
        invitationLinkAddToHome,
        invitationLinkAppName,
        invitationLinkHideHeader,
        invitationLinkHideFooter,
        invitationLinkDisableLocationCheck,
        invitationLinkLocationCheckMode,
        invitationLinkLocationRadius,
        latitude,
        longitude,
        address,
        earlyCheckinEnabled,
        earlyCheckoutEnabled,
        enableProtectGuest,
        securityAlertTime,
        ownSettings,
        settingsOrganizationName,
    };
}
